import TaTrainingVideos from '../../components/trainings/TaTrainingVideos';
import { createStore } from '../../components/trainings/store/store';
import { createApp } from 'vue';
import BootstrapVueNext from 'bootstrap-vue-next'
import 'bootstrap-vue-next/dist/bootstrap-vue-next.css'

const store = createStore();

if (document.getElementById('ta-training-videos')) {
    const app = createApp({
        components: {
            TaTrainingVideos
        },
    });
    app.use(BootstrapVueNext);
    app.use(store);
    app.mount('#ta-training-videos');
}
